// extracted by mini-css-extract-plugin
module.exports = {"book":"ComponentForm_book__FdRiX","buttons":"ComponentForm_buttons__1mjKM"};